import { SUMMARY_SOURCE } from '@src/domains/transactables/constants';
import type { SummarySource } from '@src/domains/transactables/types/summarySource';
import type { Transactable } from '@src/domains/transactables/types/transactable';

import { isCartSummaryPresentation, isDirectLinkPaymentPresentation } from './summaryPresentation';

export const resolveSummarySource = (transactable: Transactable): SummarySource => {
  if (transactable.saleChange) {
    return SUMMARY_SOURCE.SALE_CHANGE;
  }

  if (transactable.order) {
    return SUMMARY_SOURCE.ORDER;
  }

  if (transactable.directLink) {
    return SUMMARY_SOURCE.DIRECT_LINK;
  }

  if (transactable.sale) {
    return SUMMARY_SOURCE.SALE;
  }

  return SUMMARY_SOURCE.CART;
};

export const isSummaryReady = (source: SummarySource, transactable: Transactable, hasCartItems: boolean): boolean => {
  switch (source) {
    case SUMMARY_SOURCE.SALE_CHANGE:
      return Boolean(transactable.saleChange);
    case SUMMARY_SOURCE.ORDER:
      return Boolean(transactable.order);
    case SUMMARY_SOURCE.DIRECT_LINK:
      if (!transactable.directLink) {
        return false;
      }

      if (isCartSummaryPresentation(source, transactable)) {
        return hasCartItems;
      }

      if (transactable.directLink.type === 'sale') {
        return Boolean(transactable.sale);
      }

      if (isDirectLinkPaymentPresentation(source, transactable)) {
        return true;
      }

      return false;
    case SUMMARY_SOURCE.SALE:
      return Boolean(transactable.sale);
    case SUMMARY_SOURCE.CART:
      return hasCartItems;
  }
};
